// extracted by mini-css-extract-plugin
export const footer = "bn_bZ";
export const content = "bn_R";